import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { editQuestionnaire, mapSectionToPage } from 'Consts/Questionnaire';
import { questionnaireSectionNotes as enumeratedValuesQuestionnaireSectionNotes } from 'Consts/EnumeratedValues';
import EditButtonLink from 'Components/Blueprint/UI/EditButtonLink';
import Content from '../UI/Content';
import '../UI/Footnotes/index.css';

function getEditButton(simpleHousehold, footnote, isAgent) {
  if (footnote.type === 'questionnaireSectionNote') {
    const page = mapSectionToPage(footnote.attributes.sectionId);
    const link = editQuestionnaire(page, {
      isAgent,
      section: footnote.attributes.sectionId,
      householdId: simpleHousehold.householdResource.id(),
    });

    return (
      <EditButtonLink
        title="Edit Footnote"
        to={link}
      />
    );
  }

  return null;
}

const Footnotes = ({ footnotes, isAgent }) => {
  const simpleHousehold = useSimpleHousehold();

  return (
    <div className="footnotes section">
      <Content className="color-bullets-list">
        {footnotes.length > 0 ? (
          <Fragment>
            {footnotes.map((footnote, i) => (
              <div key={`${footnote.id}ft`} className="footnote">
                <div className="owner">
                  <span className="number">{i + 1}</span>
                  {footnote.meta.agent.firstName}
                  &nbsp;
                  {footnote.meta.agent.lastName}
                  &nbsp;
                  {moment(footnote.attributes.createdAt).format('MM/DD/YYYY')}
                  {getEditButton(simpleHousehold, footnote, isAgent)}
                </div>
                <div className="content">
                  {enumeratedValuesQuestionnaireSectionNotes(
                    'section',
                    footnote.attributes.sectionId,
                  ).toUpperCase()}
                  &nbsp;&middot;&nbsp;
                  {footnote.attributes.content}
                </div>
              </div>
            ))}
          </Fragment>
        ) : (
          <div>No footnotes.</div>
        )}
      </Content>
    </div>
  );
};

Footnotes.propTypes = {
  footnotes: PropTypes.array.isRequired,
  isAgent: PropTypes.bool.isRequired,
};

export default Footnotes;
